import {
    Flex,
    IconButton,
    HStack,
    Stack,
    useDisclosure,
    Container,
    Image,
    Button,
    Box,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import LanguageChanger from '../language/LanguageChanger';
import logo from './assets/images/logo.png';
import { useEffect, useState } from 'react';

export default function Header({ onButtonClick }) {
    const { t } = useTranslation();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 10);
        };

        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    const Links = [t('Accueil'), t('À propos'), t('Nos Services'), t('Biens Immobiliers'), t('Contactez-nous')];

    return (
        <Box
            position="fixed"
            top={0}
            w="100%"

            bg={scrolled ? 'rgba(26, 32, 44, 0.95)' : 'transparent'}
            backdropFilter={scrolled ? 'blur(10px)' : 'none'}
            boxShadow="sm"
            zIndex={1000}
            transition="all 0.3s"
        >
            <Container maxWidth="6xl" px={4}>
                <Flex h={16} alignItems="center" justifyContent="space-between">
                    {/* Logo */}
                    <Flex alignItems="center">
                        <Image
                            py={2}
                            width={{ base: 65, md: 70, xl: 85 }}
                            src={logo}
                            alt="APA Premium Logo"
                            transition="transform 0.3s"
                            _hover={{ transform: 'scale(1.05)' }}
                        />
                    </Flex>

                    {/* Desktop Navigation */}
                    <HStack as="nav" spacing={4} display={{ base: 'none', lg: 'flex' }}>
                        {Links.map((link, index) => (
                            <Button
                                key={link}
                                onClick={() => onButtonClick(index)}
                                rounded="20px 0 20px 0"
                                colorScheme="whiteAlpha"
                                bg="none"
                                color="white"
                                _hover={{
                                    bg: 'whiteAlpha.200',
                                    transform: 'translateY(-2px)',
                                }}
                                fontWeight="medium"
                                // _hover={{
                                //     bg: 'cyan.50',
                                //     color: 'cyan.600',
                                //     transform: 'translateY(-2px)',
                                // }}
                                transition="all 0.3s"
                            >
                                {link}
                            </Button>
                        ))}
                        <LanguageChanger />
                    </HStack>

                    {/* Mobile Menu Button */}
                    <Flex display={{ lg: 'none' }} alignItems="center">
                        <LanguageChanger />
                        <IconButton
                            colorScheme="whiteAlpha"
                            size="md"
                            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                            aria-label="Toggle Navigation"
                            onClick={isOpen ? onClose : onOpen}
                            ml={2}
                        />
                    </Flex>
                </Flex>

                {/* Mobile Menu */}
                {isOpen && (
                    <Box
                        rounded="lg"
                        bg={scrolled ? "blackAlpha.100" : 'rgba(26, 32, 44, 0.80)'}

                        backdropFilter={scrolled ? 'none' : 'blur(10px)'}

                        pb={4}
                        display={{ lg: 'none' }}
                        animation="slideDown 0.3s ease-out"
                    >
                        <Stack as="nav" spacing={4}>
                            {Links.map((link, index) => (
                                <Button
                                    key={link}
                                    onClick={() => {
                                        onButtonClick(index);
                                        onClose();
                                    }}
                                    colorScheme="whiteAlpha"
                                    bg="none"
                                    justifyContent="flex-start"
                                    _hover={{ bg: 'whiteAlpha.200' }}
                                >
                                    {link}
                                </Button>
                            ))}
                        </Stack>
                    </Box>
                )}
            </Container>
        </Box>
    );
}